export default [
    {
        comment: 'use . instead of : at the end of the sentence',
        error_id: 'GRC-01',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    }
]